export const queryKeys = {
    // for a single event
    event: (eventId: string) => [`event: ${eventId}`],
    // for all events
    events: () => [`events`],
}
